/**
 * Unified Card Loading State Component
 * Displays skeleton cards while data is loading (for statistics, dashboards, etc.)
 */

import React from 'react';
import Card from '../ui/Card';

interface CardLoadingStateProps {
  count?: number;
  columns?: 1 | 2 | 3 | 4 | 6;
  showIcon?: boolean;
  className?: string;
}

export const CardLoadingState: React.FC<CardLoadingStateProps> = ({
  count = 4,
  columns = 3,
  showIcon = true,
  className = ''
}) => {
  const gridCols = {
    1: 'grid-cols-1',
    2: 'grid-cols-1 md:grid-cols-2',
    3: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
    4: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4',
    6: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6'
  };

  return (
    <div className={`grid ${gridCols[columns]} gap-6 ${className}`}>
      {Array.from({length: count}).map((_, index) => (
        <Card key={index} className="p-6">
          <div className="animate-pulse">
            <div className="flex items-center justify-between mb-3">
              <div className="flex-1">
                <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
                <div className="h-8 bg-gray-200 rounded w-1/2"></div>
              </div>
              {showIcon && (
                <div className="w-12 h-12 bg-gray-200 rounded-full"></div>
              )}
            </div>
            {index % 2 === 0 && (
              <div className="h-3 bg-gray-200 rounded w-2/3 mt-3"></div>
            )}
          </div>
        </Card>
      ))}
    </div>
  );
};

export default CardLoadingState;


